import React, { forwardRef, ReactElement, useContext } from 'react';
import classNames from 'classnames';
import { IPageProps } from '../Page/Page';
import AuthContext from '../../contexts/authContext';
import DefaultFooter from '../../pages/_layout/_footers/DefaultFooter';
import Seo, { SeoProps } from '../../components/seo/Seo';

interface IPageWrapperProps {
	isProtected?: boolean;
	title?: string;
	description?: string;
	children:
		| ReactElement<IPageProps>
		| ReactElement<IPageProps>[];
	className?: string;
	/**
	 * Extra head content — canonical override, share image, OG type, JSON-LD.
	 * `title`/`description` above are forwarded automatically; anything here
	 * wins over them.
	 */
	seo?: Omit<SeoProps, 'title' | 'description'> & Partial<Pick<SeoProps, 'title' | 'description'>>;
}
const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
	({ isProtected = true, title, description, className, seo, children }, ref) => {
		const { user } = useContext(AuthContext);

		return (
			<div ref={ref} className={classNames('page-wrapper', 'container-fluid', className)}>
				{/*
				  Head tags used to be written imperatively here via useLayoutEffect.
				  They now go through react-helmet-async so that (a) they can be
				  snapshotted by the build-time prerenderer and (b) pages can add
				  canonical/OG/JSON-LD without touching the DOM directly.
				*/}
				<Seo title={title} description={description} {...seo} />
				{children}
				<DefaultFooter />
			</div>
		);
	},
);
PageWrapper.displayName = 'PageWrapper';

export default PageWrapper;
